export default "__VITE_ASSET__85c9d0f4__"